import DirectDownloadActionTypes from 'redux/direct-download/types';

const INITIAL_STATE = {
  downloadIds: [],
  querying: false,
  error: null,
};

function DirectDownloadReducer(state = INITIAL_STATE, { type, payload }) {
  switch (type) {
    case DirectDownloadActionTypes.SAVE_DOWNLOAD_IDS:
      return {
        ...state,
        downloadIds: [...state.downloadIds, payload],
      };

    case DirectDownloadActionTypes.QUERY_DOWNLOAD_IDS_START:
      return {
        ...state,
        querying: true,
      };
    case DirectDownloadActionTypes.QUERY_DOWNLOAD_IDS_SUCCESS:
      return {
        ...state,
        querying: false,
      };
    case DirectDownloadActionTypes.QUERY_DOWNLOAD_IDS_FAILED:
      return {
        ...state,
        querying: false,
        error: payload,
      };

    case DirectDownloadActionTypes.UPDATE_DOWNLOAD_IDS:
      return {
        ...state,
        downloadIds: payload,
      };

    default:
      return state;
  }
}

export default DirectDownloadReducer;
